import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import KakaoShareButton from './kakao';
import FacebookShareButton from './facebook';
import UrlShareButton from './url';
import classnames from 'classnames/bind';
import styles from './infoDetailArticleShareGorup.module.scss';

const cx = classnames.bind(styles);

interface InfoDetailArticleShareGroupProps {
  title: string;
  label: string;
  thumbnailUrl: string;
}

const InfoDetailArticleShareGroup = (props: InfoDetailArticleShareGroupProps) => {
  const { title, label, thumbnailUrl } = props;
  const router = useRouter();
  const [url, setUrl] = useState('');

  useEffect(() => {
    // Router 내 현재 페이지의 Full URL을 가져올 수 없어서 window 객체를 활용하여 작업하였습니다.
    setUrl(window.location.href);
  }, [router]);

  return (
    <ul className={cx('shareGroup')}>
      <KakaoShareButton title={title} description={label} imageUrl={thumbnailUrl} webUrl={url} mobileWebUrl={url} />
      <FacebookShareButton title={title} url={url} />
      <UrlShareButton url={url} />
    </ul>
  );
};

export default InfoDetailArticleShareGroup;
